module.exports = __webpack_public_path__ + "static/media/vod32.a2177bbb.png";